<div class="facility-details-add-container"
     *ngIf="facilityDobryAgentObject"
     [formGroup]="facilityDobryAgentForm"
     fxLayout="column"
     fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Dane placówki</h3>
        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Nazwa placówki</mat-label>
            <input matInput formControlName="name">
          </mat-form-field>

          <div fxFlex="100" class="editor-field">
            <label class="editor-field__label">Opis</label>
            <angular-editor
              formControlName="description"
              [config]="editorConfig">
            </angular-editor>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <app-dict-dobry-agent-select
            fxFlex="50"
            label="Typ placówki"
            dictType="facility_type"
            formControlName="type">
          </app-dict-dobry-agent-select>

          <app-dict-dobry-agent-select
            fxFlex="50"
            label="Obsługa"
            dictType="facility_service_type"
            formControlName="serviceType">
          </app-dict-dobry-agent-select>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="50">
            <mat-label>Nr telefonu</mat-label>
            <input matInput formControlName="phoneNumber">
          </mat-form-field>

          <mat-form-field fxFlex="50">
            <mat-label>Adres e-mail</mat-label>
            <input matInput formControlName="email">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Status wizytówki</mat-label>

            <mat-select formControlName="active">
              <mat-option [value]="true">
                Aktywna
              </mat-option>

              <mat-option [value]="false">
                Nieaktywna
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card formGroupName="address">
        <h3>Adres placówki</h3>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="50">
            <mat-label>Ulica</mat-label>
            <input matInput formControlName="street">
          </mat-form-field>

          <mat-form-field fxFlex="25">
            <mat-label>Nr domu</mat-label>
            <input matInput formControlName="houseNumber">
          </mat-form-field>
          <mat-form-field fxFlex="25">
            <mat-label>Nr lokalu</mat-label>
            <input matInput formControlName="apartmentNumber">
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
          <mat-form-field fxFlex="20">
            <mat-label>Kod pocztowy</mat-label>
            <input matInput placeholder="10-200" formControlName="zipCode" mask="99-999" [showMaskTyped]="true" [dropSpecialCharacters]="false">
            <mat-error *ngIf="facilityDobryAgentForm.get('address.zipCode').hasError('required')">To pole jest wymagane</mat-error>
            <mat-error *ngIf="facilityDobryAgentForm.get('address.zipCode').hasError('invalidZipCode')">Podaj prawidłowy kod pocztowy</mat-error>
          </mat-form-field>
          <app-city-dobry-agent-select
            fxFlex="80"
            label="Miasto"
            formControlName="city"
            (citySelected)="onCitySelected($event)">
          </app-city-dobry-agent-select>
        </div>
      </mat-card>
      <mat-card formGroupName="openHours">
        <h3>Godziny otwarcia</h3>
        <div
          *ngFor="let day of openingHoursDays"
          [formGroupName]="day.key"
          class="opening-hours-edit-row"
          fxLayout="row"
          fxLayoutGap="15px"
          fxLayoutAlign="start center"
          fxLayout.lt-md="column"
        >
          <div fxFlex="25">
            <strong>{{ day.label }}</strong>
          </div>

          <mat-checkbox
            fxFlex="20"
            formControlName="closed"
            (change)="onClosedChange(day.key)">
            Nieczynne
          </mat-checkbox>
          <mat-form-field fxFlex="25">
            <mat-label>Otwarcie</mat-label>
            <input
              matInput
              type="time"
              formControlName="openTime">
          </mat-form-field>

          <mat-form-field fxFlex="25">
            <mat-label>Zamknięcie</mat-label>
            <input
              matInput
              type="time"
              formControlName="closeTime">
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card>
        <h3>Daty nieobecności</h3>

        <div fxLayout="column" fxLayoutGap="15px">

          <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
            <app-datepicker
              fxFlex="70"
              label="Pojedynczy dzień nieobecności"
              placeholder="YYYY-MM-DD"
              [control]="dayOffDateControl">
            </app-datepicker>

            <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="addSingleDayOff()">
                <mat-icon>add</mat-icon>
                <span>Dodaj dzień</span>
              </button>
            </div>
          </div>

          <div fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column">
            <app-datepicker
              fxFlex="35"
              label="Nieobecność od"
              placeholder="YYYY-MM-DD"
              [control]="dayOffDateFromControl">
            </app-datepicker>

            <app-datepicker
              fxFlex="35"
              label="Nieobecność do"
              placeholder="YYYY-MM-DD"
              [control]="dayOffDateToControl">
            </app-datepicker>

            <div fxFlex="30" fxLayout="row" fxLayoutAlign="start center">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="addDayOffRange()">
                <mat-icon>date_range</mat-icon>
                <span>Dodaj zakres</span>
              </button>
            </div>
          </div>

          <div
            *ngIf="daysOffFromWorkArray.length > 0"
            fxLayout="row wrap"
            fxLayoutGap="8px"
            class="days-off-list">

            <mat-chip
              *ngFor="let control of daysOffFromWorkArray.controls; let i = index"
              [removable]="true"
              (removed)="removeDayOff(i)">

              {{ control.value }}

              <button matChipRemove type="button">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </div>

          <app-detail
            *ngIf="daysOffFromWorkArray.length === 0"
            header="Daty nieobecności"
            value="Brak zdefiniowanych nieobecności">
          </app-detail>
        </div>
      </mat-card>
      <mat-card>
        <h3>Wizytówka google</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <app-google-place-dobry-agent-select
            label="Wyszukaj wizytówkę Google"
            formControlName="googlePlaceId"
            (placeSelected)="onGooglePlaceSelected($event)">
          </app-google-place-dobry-agent-select>

          <mat-form-field fxFlex="100">
            <mat-label>Google Place ID</mat-label>
            <input matInput formControlName="googlePlaceId">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>Google URL</mat-label>
            <input matInput formControlName="googleBusinessUrl">
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card>
        <h3>SEO</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>SEO Slug</mat-label>
            <input matInput formControlName="seoSlug">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>SEO Title</mat-label>
            <input matInput formControlName="seoTitle">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>SEO Description</mat-label>
            <textarea matInput formControlName="seoDescription" rows="3"></textarea>
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>SEO Keywords</mat-label>
            <textarea matInput formControlName="seoKeywords" rows="2"></textarea>
          </mat-form-field>
        </div>
      </mat-card>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Zdjęcia</h3>
        <app-image-drag-and-drop
          formControlName="images"
          [baseUrl]="dobryAgentBaseUrl"
          [maxSize]="3 * 1024 * 1024"
          [maxTotalSize]="8 * 1024 * 1024">
        </app-image-drag-and-drop>
      </mat-card>
      <mat-card>
        <h3>Dodatkowe</h3>
        <app-sub-category-dobry-agent-select
          label="Podkategorie"
          formControlName="subCategories">
        </app-sub-category-dobry-agent-select>
        <app-insurance-company-dobry-agent-select
          label="Towarzystwa ubezpieczeniowe"
          formControlName="insuranceCompanies">
        </app-insurance-company-dobry-agent-select>
        <app-payment-method-dobry-agent-select
          label="Metody płatności"
          formControlName="paymentMethods">
        </app-payment-method-dobry-agent-select>
        <div fxLayout="column" fxLayoutGap="15px">
          <mat-checkbox formControlName="parking">
            Parking przy placówce
          </mat-checkbox>

          <mat-checkbox formControlName="accessibilityFeatures">
            Udogodnienia dla niepełnosprawnych
          </mat-checkbox>

          <mat-checkbox formControlName="bestAgents">
            Najlepsi agenci
          </mat-checkbox>
        </div>
      </mat-card>
      <mat-card>
        <h3>Strona www</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="100">
            <mat-label>Facebook</mat-label>
<!--            <span matPrefix>https://&nbsp;</span>-->
            <input
              matInput
              formControlName="facebook"
              placeholder="www.facebook.com/nazwa">
          </mat-form-field>

          <mat-form-field fxFlex="100">
            <mat-label>Strona www</mat-label>
<!--            <span matPrefix>https://&nbsp;</span>-->
            <input
              matInput
              formControlName="website"
              placeholder="www.twojastrona.pl">
          </mat-form-field>
        </div>
      </mat-card>
      <mat-card>
        <h3>Produkty Chronie.pl</h3>

        <div fxLayout="column" fxLayoutGap="15px">
          <app-affiliate-code-dobry-agent-select
            label="Kod zniżkowy Chronie.pl"
            formControlName="affiliateCode"
            [ofwcas]="ofwcasDataSource.data">
          </app-affiliate-code-dobry-agent-select>
        </div>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <h3>Doradcy Placówki</h3>

        <table mat-table [dataSource]="ofwcasDataSource">

          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef>Imię i nazwisko</th>
            <td mat-cell *matCellDef="let element">
              {{ element.firstName }} {{ element.lastName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
              <button mat-raised-button [ngClass]="element.status?.color + '-button'">
                {{ element.status?.name }}
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef>Numer telefonu</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-form-field class="table-form-field">
                <mat-label>Telefon</mat-label>
                <input
                  matInput
                  appCapitalizeFirst
                  placeholder="Nr telefonu"
                  prefix="+48" mask=" 000 000 000"
                  [formControl]="getOfwcaPermissionControl(i, 'phone')">
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-form-field class="table-form-field">
                <mat-label>Email</mat-label>
                <input
                  matInput
                  [formControl]="getOfwcaPermissionControl(i, 'email')">
                <mat-error *ngIf="getOfwcaPermissionControl(i, 'email').hasError('email')">
                  Nieprawidłowy email
                </mat-error>
              </mat-form-field>
            </td>
          </ng-container>

          <ng-container matColumnDef="portalDa">
            <th mat-header-cell *matHeaderCellDef>Widoczny na portalu DA</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <mat-checkbox
                [formControl]="getOfwcaPermissionControl(i, 'visibleOnDobryAgent')">
              </mat-checkbox>

<!--              <div class="permission-source" *ngIf="getDobryAgentCoordinator(element) as coordinator">-->
<!--                Agent DA: {{ coordinator.firstName }} {{ coordinator.lastName }}-->
<!--                <span *ngIf="!coordinator.active">(nieaktywny)</span>-->
<!--              </div>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="blog">
            <th mat-header-cell *matHeaderCellDef>Uprawnienia - blog</th>
            <td mat-cell *matCellDef="let element; let i = index">

              <ng-container *ngIf="hasUser360Account(element); else noUser360Blog">
                <mat-checkbox
                  [formControl]="getOfwcaPermissionControl(i, 'blogAccess')">
                </mat-checkbox>
              </ng-container>

              <ng-template #noUser360Blog>
                Brak konta ASF360
              </ng-template>

            </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef>Uprawnienia - edycja wizytówki</th>
            <td mat-cell *matCellDef="let element; let i = index">

              <ng-container *ngIf="hasUser360Account(element); else noUser360Edit">
                <mat-checkbox
                  [formControl]="getOfwcaPermissionControl(i, 'businessCardEditAccess')">
                </mat-checkbox>
              </ng-container>

              <ng-template #noUser360Edit>
                Brak konta ASF360
              </ng-template>

            </td>
          </ng-container>

          <ng-container matColumnDef="avatar">
            <th mat-header-cell *matHeaderCellDef>Avatar</th>

            <td mat-cell *matCellDef="let element; let i = index">
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="agent-avatar">
                  <img
                    *ngIf="getAgentAvatarUrl(element); else noAgentAvatar"
                    [src]="getAgentAvatarUrl(element)"
                    alt="Avatar doradcy">

                  <ng-template #noAgentAvatar>
                    <mat-icon>person</mat-icon>
                  </ng-template>
                </div>

                <input
                  #agentImageInput
                  type="file"
                  hidden
                  accept="image/jpeg,image/png,image/webp"
                  (change)="onAgentImageSelected($any($event.target).files, element, i); agentImageInput.value = ''">

                <button
                  mat-stroked-button
                  color="primary"
                  type="button"
                  [disabled]="!resolveDobryAgentAgentId(element) || isAgentImageUploading(element)"
                  (click)="agentImageInput.click()">

                  <mat-icon *ngIf="!isAgentImageUploading(element)">upload</mat-icon>
                  <mat-icon *ngIf="isAgentImageUploading(element)">hourglass_empty</mat-icon>

                  <span>  {{ getAgentAvatarUrl(element) ? 'Zmień' : 'Dodaj' }}    </span>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </mat-card>
    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            mat-stroked-button color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
</div>
